import { OperationTypeEnum } from '@/@types/Operation';

// Os campos de quilometragem guardam horas quando a operação é por horas.
export function getMileageUnit(operationType?: OperationTypeEnum | null) {
  return operationType === OperationTypeEnum.HOURS ? 'h' : 'km';
}
